"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _fieldErrorIcon = _interopRequireDefault(require("./errors/fieldErrorIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Select = function Select(_ref) {
  var customProps = _ref.customProps,
    error = _ref.error,
    errorMessages = _ref.errorMessages,
    formatValue = _ref.formatValue,
    inputRef = _ref.inputRef,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    options = _ref.options,
    validate = _ref.validate,
    value = _ref.value;
  var id = "payment-widget__checkout__".concat(name);
  var handleChange = function handleChange(e) {
    var value = formatValue ? formatValue(e) : e.target.value;
    var error = validate ? validate(errorMessages, value, customProps) : '';
    var payload = {
      value: value,
      error: error
    };
    onChange(_defineProperty({}, e.target.name, payload));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout__field__container",
    ref: inputRef
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "payment-checkout__label"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'payment-checkout__label__text ' + (error.length > 0 ? 'payment-checkout__label__text--error' : '')
  }, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-checkout__input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", {
    className: 'payment-widget__checkout__field ' + (error.length ? 'payment-widget__checkout__fields__input__error' : ''),
    name: name,
    id: id,
    "aria-describedby": "error-".concat(name),
    onChange: handleChange,
    value: value
  }, name != 'country' && /*#__PURE__*/_react.default.createElement("option", null), options), error.length > 0 && /*#__PURE__*/_react.default.createElement(_fieldErrorIcon.default, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "payment-widget__checkout__field__error",
    id: "error-".concat(name),
    "aria-live": "assertive",
    role: "status"
  }, error));
};
Select.propTypes = {
  customProps: _propTypes.default.object,
  error: _propTypes.default.string,
  errorMessages: _propTypes.default.object,
  formatValue: _propTypes.default.func,
  inputRef: _propTypes.default.func,
  label: _propTypes.default.string,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  options: _propTypes.default.array,
  validate: _propTypes.default.func,
  value: _propTypes.default.string
};
var _default = Select;
exports.default = _default;